export default __webpack_public_path__ + "static/media/full-face-helmet.be3fb2dc.svg";